<script setup lang="ts">
import { IPhoneWrapper } from '@caks/shared/modules/i'
import { ButtonMain } from '@caks/uikit/button'
import { vMaska } from 'maska'
import { computed } from 'vue'
import { InputField } from '@caks/uikit/input'
import { postPhoneAuth } from '@caks/shared/api/user.route'

interface Props {
  phone: string
}

interface Emit {
  (emit: 'update:phone', value: string): void
  (emit: 'to-next-step'): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emit>()

const phoneProxy = computed({
  get() {
    return props.phone
  },
  set(value: string) {
    emit('update:phone', value)
  },
})

const toNextStep = async () => {
  await postPhoneAuth({
    phone: props.phone.replace(/\D/g, ''),
    type: 'tg'
  })

  emit('to-next-step')
}
</script>

<template>
  <i-phone-wrapper title="Нужен ваш номер телефона" small-text desktop style="width: 384px">
    <template #default>
      <input-field
        v-maska
        data-maska="+7-###-###-##-##"
        v-model="phoneProxy"
        no-icons
        placeholder="Номер телефона" />
    </template>
    <template #subtitle>Пригодится при оформлении заказа</template>
    <template #caption>
      Продолжая, вы соглашаетесь со сбором, обработкой персональных данных и
      <a class="auth__user-agreement" href="/Соглашение_об_оказании_услуг_вер_17_01_4.docx" target="_blank">Пользовательским соглашением</a>
    </template>
    <template #button>
      <button-main :disabled="phone.length < 16" @click="toNextStep"> Продолжить </button-main>
    </template>
  </i-phone-wrapper>
</template>
